import { Button, Col, Form, Input, Row, Spin } from 'antd'
import ModalAddress from 'components/Modal/ModalAddress'
import { useCallback, useEffect, useState } from 'react'
import { locationService, customerService, orderService } from 'services'
import { IProvinceData } from 'state/location/actions'
import useGetProvince from 'state/location/hooks/useGetLocation'
import ModalChooseAddress from './ModalChooseAddress'
import { toast } from 'react-toastify'

const { TextArea, Search } = Input

const DeliveryForm = ({form, provinceId=0, districtId=0, wardId=0, editData = undefined, formType, dataDetail, cbUserInfo }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { setFieldsValue, getFieldsValue } = form
  const { provinceList } = useGetProvince()

  const [districtList, setDistrictList] = useState<IProvinceData[]>([])
  const [wardList, setWardList] = useState<IProvinceData[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isOpenSaveAddress, setOpenSaveAddress] = useState(true)
  const [loadingSaveAddress, setLoadingSaveAddress] = useState(false)
  const [count, setCount] = useState(0)
  const [userInput, setUserInput] = useState('')
  const [loadingGetInfo, setLoadingGetInfo] = useState(false)
  const nTpe = formType === 'delivery' ? 'gửi' : 'nhận';
  const [userInputNote, setUserInputNote] = useState('')

  const [modalModify, setModalModify] = useState({
    open: false,
    data: undefined,
  })

  const handleShowModal = () => {
    setIsModalOpen((prev) => !prev)
  }

  const handleShowModify = (itemData) => {
    setModalModify((prev) => ({
      open: !prev.open,
      data: itemData,
    }))
  }
  const saveAddress = () => {
    setLoadingSaveAddress(true)
    const full_name = getFieldsValue()[`${formType}_full_name`]
    const phone_number = getFieldsValue()[`${formType}_phone_number`]
    const email = getFieldsValue()[`${formType}_email`]
    const province_id = getFieldsValue()[`${formType}_province_id`]
    const district_id = getFieldsValue()[`${formType}_district_id`]
    const ward_id = getFieldsValue()[`${formType}_ward_id`]
    const address = getFieldsValue()[`${formType}_address`]
    customerService.createAddress(
      formType,
      { full_name, phone_number, email, province_id, district_id, ward_id, address },
      () => {
        setOpenSaveAddress(true)
        setLoadingSaveAddress(false)
        setCount((prev) => (prev += 1))
      },
      (response) => {
        toast.error(response?.message || 'Tạo không thành công', {
          autoClose: false,
        })
        setLoadingSaveAddress(false)
      }
    )
  }
  const onSearchAddress = () => {
    handleShowButtonSave()
  }
  const handleShowButtonSave = () => {
    const full_name = getFieldsValue()[`${formType}_full_name`]
    const phone_number = getFieldsValue()[`${formType}_phone_number`]
    const email = getFieldsValue()[`${formType}_email`]
    const province_id = getFieldsValue()[`${formType}_province_id`]
    const district_id = getFieldsValue()[`${formType}_district_id`]
    const ward_id = getFieldsValue()[`${formType}_ward_id`]
    const address = getFieldsValue()[`${formType}_address`]
    if (formType === 'delivery') {
      if (full_name && phone_number && email && province_id && district_id && ward_id && address) {
        setOpenSaveAddress(false)
      } else {
        setOpenSaveAddress(true)
      }
    } else {
      if (full_name && phone_number && province_id && district_id && ward_id && address) {
        setOpenSaveAddress(false)
      } else {
        setOpenSaveAddress(true)
      }
    }

  }

  useEffect(() => {
    if (provinceId) {
      handleChangeLocation('province',provinceId).then(() => {
        handleChangeLocation('district',districtId).then();
      });
    }
  }, [provinceId,districtId])

  const handleCloseModalModify = () =>
    setModalModify({
      open: false,
      data: undefined,
    })

  const handleChooseAddress = async (type, address) => {
    handleShowModal()
    setLoading(true)
    await handleChangeLocation('province', address?.province_id)
    await handleChangeLocation('district', address?.district_id)

    setFieldsValue({
      [`${type}_full_name`]: address?.full_name,
      [`${type}_phone_number`]: address?.phone_number,
      [`${type}_email`]: address?.email,
      [`${type}_province_id`]: address?.province_id,
      [`${type}_district_id`]: address?.district_id,
      [`${type}_ward_id`]: address?.ward_id,
      [`${type}_address`]: address?.address,
    })

    if (type === 'delivery') {
      setFieldsValue({
        [`note`]: `Gọi trước khi qua lấy hàng - Điện thoại: ${address?.phone_number}`,
      })
    }
    setLoading(false)
  }

  const handleChangeLocation = useCallback(
    async (type, id) => {
      if (type === 'province') {
        setFieldsValue({
          district_id: undefined,
          ward_id: undefined,
        })
        await locationService.getDistrict(id, (res) => setDistrictList(res?.districts))
        setWardList([])
        handleShowButtonSave()
      }
      if (type === 'district') {
        setFieldsValue({
          ward_id: undefined,
        })
        if(id){
          await locationService.getWard(id, (res) => setWardList(res?.wards))
          handleShowButtonSave()
        }else{
          setTimeout(async function() {
            if(id){
              await locationService.getWard(id, (res) => setWardList(res?.wards))
              handleShowButtonSave()
            }
          },1000);
        }
      }
    },
    [setFieldsValue]
  )
  const handleUserInput = (e) => {
    setUserInput(e?.target?.value);
  }
  const handleShowInputError = (data) => {
    if(data?.address?.province?.id){
      if(data?.address?.district?.id){
        if(!data?.address?.ward?.id){
          setUserInputNote('Không tìm thấy: phường/xã thích hợp');
        }
      }else{
        setUserInputNote('Không tìm thấy: quận/huyện, phường/xã thích hợp');
      }
    }else{
      setUserInputNote('Không tìm thấy: tỉnh/thành, quận/huyện, phường/xã thích hợp');
    }
  }
  const beginGetUserInfo = (str : string) => {
    setLoadingGetInfo(true);
    orderService.getUserInputInfo(
      {'input': str},
      (response) => {
        const info = response?.data;
        handleShowInputError(info);
        cbUserInfo(info,formType);
        setTimeout(function(){
          handleChangeLocation('province',info?.address?.province?.id).then(() => {
            handleChangeLocation('district',info?.address?.district?.id).then();
          });
        },500);
        setLoadingGetInfo(false);
      }
    )
  }
  const handleGetInfo = () => {
    setUserInputNote('');
    if(userInput?.length){
      beginGetUserInfo(userInput);
    }else{
      handleFormSubmit().then();
    }
  }
  const handleFormSubmit = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setUserInput(text);
      beginGetUserInfo(text);
    } catch (err) {
      console.log('no');
    }
  };
  useEffect(() => {
    if (editData) {
      const { address, district_id, email, full_name, phone_number, province_id, ward_id } = editData

      handleChangeLocation('province', province_id)
      handleChangeLocation('district', district_id)

      setFieldsValue({
        address,
        district_id,
        email,
        full_name,
        phone_number,
        province_id,
        ward_id,
      });
    }
  }, [editData, setFieldsValue, handleChangeLocation])

  useEffect(() => {
    if (dataDetail) {
      handleChangeLocation('province', dataDetail?.sender?.province?.id)
      handleChangeLocation('district', dataDetail?.sender?.district?.id)
    }
  }, [dataDetail, handleChangeLocation])

  return (
    <>
      {!dataDetail && (
        <Col span={24} className='button-add'>
          <div style={{ textAlign: 'center' }}>
            <Button type='primary' onClick={handleShowModal} loading={loading}>
              Chọn thông tin {formType === 'delivery' ? 'gửi' : 'nhận'} hàng
            </Button>
          </div>
        </Col>
      )}

      <Form
        form={form}
        layout='horizontal'
        labelCol={{ span: 5, md: { span: 4 }, lg: { span: 4 }, xxl: { span: 3 } }}
        wrapperCol={{ span: 20, lg: { span: 20 }, xxl: { span: 21 } }}
      >
        <Row gutter={[24, 0]}>
          <Col span={24}>
            <Form.Item name='item-get-info' label={'Thông tin người ' + nTpe}>
              <TextArea value={userInput}  onChange={handleUserInput} rows={3} maxLength={300} placeholder='Điền Tên, Số điện thoại, Địa chỉ...'/>
              <Button loading={loadingGetInfo} onClick={handleGetInfo} style={{marginTop:'10px'}}>{userInput ? 'Điền tự động' : 'Dán và nhập tự động'}</Button>
              <div style={{float:'right',color:'red',marginTop:'10px'}}>{userInputNote}</div>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='Tên đại diện'
              name={`${formType}_full_name`}
              rules={[{ required: true, message: 'Vui lòng nhập Tên đại diện!' }]}
            >
              <Input placeholder='Nhập Tên đại diện' onChange={onSearchAddress} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label='Số điện thoại'
              name={`${formType}_phone_number`}
              rules={[{ required: true, message: 'Vui lòng nhập Số điện thoại' }]}
            >
              <Input placeholder='Nhập Số điện thoại' onChange={onSearchAddress} />
            </Form.Item>
          </Col>

          {formType === 'delivery' && (
            <Col span={24}>
              <Form.Item
                label='Email'
                name={`${formType}_email`}
                rules={[
                  { required: true, message: 'Vui lòng nhập Email' },
                  {
                    type: 'email',
                    message: 'Email sai định dạng!',
                  },
                ]}
              >
                <Input placeholder='Nhập email' onChange={onSearchAddress} />
              </Form.Item>
            </Col>
          )}

          <Col span={24}>
            <Form.Item
              name={`${formType}_province_id`}
              label='Tỉnh / Thành'
              rules={[{ required: true, message: 'Vui lòng chọn Tỉnh / Thành' }]}
            >
              <select
                className='custom-select'
                onChange={(e) => {
                  handleChangeLocation('province', e?.target?.value)
                }}
                disabled={!!dataDetail}
              >
                <option value=''>Chọn tỉnh / thành</option>
                {provinceList?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={`${formType}_district_id`}
              label='Quận / Huyện'
              rules={[{ required: true, message: 'Vui lòng chọn Quận / Huyện' }]}
            >
              <select
                className='custom-select'
                onChange={(e) => handleChangeLocation('district', e?.target?.value)}
                disabled={!!dataDetail}
              >
                <option value=''>Chọn quận / huyện</option>
                {districtList?.map((item) => (
                  <option value={item.id} key={item.id} selected={item.id===districtId}>
                    {item.title}
                  </option>
                ))}
              </select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={`${formType}_ward_id`}
              label='Phường / Xã'
              rules={[{ required: true, message: 'Vui lòng chọn Phường / Xã' }]}
            >
              <select className='custom-select' disabled={!!dataDetail} onChange={onSearchAddress}>
                <option value=''>Chọn phường / xã</option>
                {wardList?.map((item) => (
                  <option value={item.id} key={item.id} selected={item.id===wardId}>
                    {item.title}
                  </option>
                ))}
              </select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label='Địa chỉ'
              name={`${formType}_address`}
              rules={[{ required: true, message: 'Vui lòng nhập Địa chỉ' }]}
            >
              <Search
                placeholder="Nhập địa chỉ"
                loading={loadingSaveAddress}
                enterButton={
                  <Button disabled={isOpenSaveAddress} loading={loadingSaveAddress} onClick={saveAddress}>Lưu</Button>
                }
                size="large"
                onChange={onSearchAddress}
              />
            </Form.Item>
          </Col>

          {formType === 'delivery' && (
            <Col span={24}>
              <Form.Item label='Ghi chú' name='note'>
                <TextArea rows={3} />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>

      <ModalChooseAddress
        open={isModalOpen}
        onCancel={handleShowModal}
        type={formType}
        onChooseAddress={handleChooseAddress}
        onAddAddress={handleShowModify}
        refreshData={count}
      />
      <ModalAddress
        open={modalModify.open}
        onCancel={handleCloseModalModify}
        type={formType}
        editData={modalModify.data}
        refreshData={() => setCount((prev) => (prev += 1))}
      />
    </>
  )
}

export default DeliveryForm
